import React, { Fragment } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Card from '../../../../components/Card/Card';
import StatisticsTable from '../../../../components/Statistics/StatisticsTable';
import StatisticsFilters from '../../../../components/Statistics/StatisticsFilters/StatisticsFilters';
import StatisticsConversionsTable from '../../../../components/Statistics/StatisticsConversionsTable/StatisticsConversionsTable';
import StatisticsGoalsTable from '../../../../components/Statistics/StatisticsGoalsTable';
import Pagination from '../../../../components/Pagination/Pagination';
import StatisticsRefreshButton from '../../../../components/Statistics/StatisticsRefreshButton';
import StatisticsSubSections from '../../../../components/Statistics/StatisticsSubSections';
import StatisticsTabs from './StatisticsTabs';
import StatisticsConversionsTotal from './StatisticsConversionsTotal';
import StatisticsTableSettings from './StatisticsTableSettings';
import StatisticsShare from '@components/Statistics/StatisticsShare';
const fixtureData = [5, 191, 0, 3, 106];

const getTitle = (type = {}) => {
  if (type === 'leads') {
    return (
      <FormattedMessage
        id="navigation.statistics.times.conversions.theme_3"
        defaultMessage="Leads"
      />
    );
  }
  return (
    <FormattedMessage
      id="navigation.statistics.times.theme_3"
      defaultMessage="Summary statistics"
    />
  );
};

const customStrings = {
  group: {
    Коэффициенты: 'Показатели',
  },
  field: {
    regex: 'Trash|Треш',
    replace: <FormattedMessage id="statistics.fields.trash.theme_3" defaultMessage="Trash" />,
  },
};

const Statistics = ({
  data: {
    config,
    currencies,
    hideFilters,
    isMembers,
    isMember,
    className,
    tab,
    loading,
    type,
    tabs,
    stats,
    total,
    page,
    limit,
    pageCount,
    isMounted,
    startCreateWebmasterPreset,
    startUpdateWebmasterPreset,
    startRemoveWebmasterPreset,
    showAlert,
    currency,
    resetFilters,
    isPagination,
    isSharing,
    requestParams,
    theme,
  },
  cardHeaderRef,
  handleRefresh,
  handleSectionChange,
  changeCurrency,
  setPagesCount,
  handleDeleteSlave,
  handlePageChange,
  handleFilterUpdate,
  handleTabChange,
  updateTableSettings,
  setSharingState,
}) => {
  const title = getTitle(type);
  const hideSubSections = [
    'landings',
    'transits',
    'times',
    'hourly',
    'subs1',
    'subs2',
    'subs3',
    'subs4',
    'subs5',
    'subs',
  ].includes(type);

  return (
    <Fragment>
      {/* заголовок не должен появляться на странице команды */}
      {!isMembers && <h3 className="page-title">{title}</h3>}

      {!hideFilters && (
        <Card.WithControls
          className={`statistics ${className ? className : ''}`}
          loading={loading}
          title={<FormattedMessage id="offers.filters.title" defaultMessage="Filters" />}
          controls={[<StatisticsRefreshButton onRefresh={handleRefresh} />]}
          localStorageName={'StatisticsFilters'}
          collapsing={true}
        >
          {/* Statistics Filters */}
          <Card.Body className="no-padding">
            <Row>
              <Col>
                <StatisticsFilters
                  onCreatePreset={startCreateWebmasterPreset}
                  onSavePreset={startUpdateWebmasterPreset}
                  onRemovePreset={startRemoveWebmasterPreset}
                  onFilterUpdate={handleFilterUpdate}
                  onRefresh={handleRefresh}
                  showAlert={showAlert}
                  currency={currency}
                  currencies={currencies}
                  onCurrencyChange={changeCurrency}
                  hideFilters={hideFilters}
                  tab={tab}
                  resetFilters={resetFilters}
                  type={type}
                  handleSectionChange={handleSectionChange}
                  stats={stats}
                  total={total}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card.WithControls>
      )}

      {/* {type === 'leads' && <StatisticsConversionsTotal data={fixtureData} />} */}

      {/* Statistics Table */}
      <Card>
        {type !== 'leads' && (
          <Card.Header className="statistics-table-head no-padding">
            <div className="card-with-controls-header-text">
              <FormattedMessage id="statistics.filters.title.theme_3" defaultMessage="Group by" />
            </div>
            <StatisticsTabs tabs={tabs} type={type} onTabChange={handleTabChange} />
            <StatisticsTableSettings config={config} updateTableSettings={updateTableSettings} />
          </Card.Header>
        )}
        <Card.Body className="table-container table-container-statistics">
          {!hideSubSections && !hideFilters && tab && tab.id && tab.tabs && (
            <Row className="statistic-sub-section-container">
              <Col sm="12" md="8" lg="9">
                <StatisticsSubSections type={type} onChange={handleSectionChange} {...tab} />
              </Col>
            </Row>
          )}
          {type === 'leads' && (
            <StatisticsConversionsTable
              config={config}
              currency={currency}
              currencies={currencies}
              stats={stats}
              page={page}
              limit={limit}
              setPagesCount={setPagesCount}
              loading={loading}
              isMounted={isMounted}
              isMember={isMember}
              isPagination={isPagination}
            />
          )}
          {type === 'pixels' && (
            <StatisticsGoalsTable
              config={config}
              currency={currency}
              stats={stats}
              total={total}
              limit={limit}
              page={page}
              setPagesCount={setPagesCount}
              tab={type}
              loading={loading}
              isMounted={isMounted}
              isMember={isMember}
              isPagination={isPagination}
              customStrings={customStrings}
            />
          )}

          {type !== 'leads' && type !== 'pixels' && (
            <StatisticsTable
              config={config}
              currency={currency}
              stats={stats}
              total={total}
              page={page}
              limit={limit}
              setPagesCount={setPagesCount}
              tab={type}
              loading={loading}
              isMembers={isMembers}
              handleDeleteSlave={handleDeleteSlave}
              isMounted={isMounted}
              isMember={isMember}
              isPagination={isPagination}
              customStrings={customStrings}
            />
          )}
        </Card.Body>

        {/* Statistics Pages */}
        {!loading && (
          <Card.Footer>
            {pageCount > 1 && (
              <Pagination
                affectUrl
                pageCount={pageCount}
                onPageChange={handlePageChange}
                activePage={page + 1}
                scrollToAfterPageChanged={{ ref: cardHeaderRef.current }}
              />
            )}
            {!isMember && (
              <StatisticsShare
                isLoading={isSharing}
                setSharingState={setSharingState}
                showAlert={showAlert}
                requestParams={requestParams}
                theme={theme}
              />
            )}
          </Card.Footer>
        )}
      </Card>
    </Fragment>
  );
};

export default Statistics;
